import { memo } from "react";
import { Box } from "@/shared/ui/base";
import type { BaseComponentProps } from "@/shared/ui/base/types";

export interface RailwayLineLogoProps extends BaseComponentProps {
  lineCode: string;
  color: string;
  size?: number;
}

export const RailwayLineLogo = memo(function RailwayLineLogo({
  lineCode,
  color,
  size = 24,
  className,
}: RailwayLineLogoProps) {
  if (!lineCode || !color) {
    return null;
  }

  const isSingleChar = lineCode.length === 1;

  if (isSingleChar) {
    return (
      <Box
        as="svg"
        width={size}
        height={size}
        viewBox="0 0 100 100"
        className={className}
        role="img"
        aria-label={`${lineCode} line`}
      >
        <Box as="circle" cx="50" cy="50" r="50" fill={color} />
        <Box as="circle" cx="50" cy="50" r="32" fill="white" />
        <Box
          as="text"
          x="50"
          y="50"
          fill="black"
          fontSize={52}
          fontWeight="bold"
          fontFamily="Arial, Helvetica, sans-serif"
          textAnchor="middle"
          dominantBaseline="central"
        >
          {lineCode}
        </Box>
      </Box>
    );
  }

  const fontSize = lineCode.length === 2 ? 44 : 32;
  const borderRadius = 15;
  const borderWidth = 12;

  return (
    <Box
      as="svg"
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      role="img"
      aria-label={`${lineCode} line`}
    >
      <Box
        as="rect"
        x="0"
        y="0"
        width="100"
        height="100"
        rx={borderRadius}
        ry={borderRadius}
        fill={color}
      />
      <Box
        as="rect"
        x={borderWidth}
        y={borderWidth}
        width={100 - borderWidth * 2}
        height={100 - borderWidth * 2}
        rx={borderRadius - 4}
        ry={borderRadius - 4}
        fill="white"
      />
      <Box
        as="text"
        x="50"
        y="50"
        fill="black"
        fontSize={fontSize}
        fontWeight="bold"
        fontFamily="Arial, Helvetica, sans-serif"
        textAnchor="middle"
        dominantBaseline="central"
      >
        {lineCode}
      </Box>
    </Box>
  );
});

RailwayLineLogo.displayName = "RailwayLineLogo";
export default RailwayLineLogo;
